import { DownloadIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Heading,
  Image,
  Link,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { EMonthsTicket } from "../../const.ts";
import {
  useMyOrdersTicketId,
  useMyTicketsDownload,
} from "../../hooks/useMyOrdersTicketId.ts";
import { useTranslation } from "react-i18next";

interface IProps {
  eventId: string;
  eventName: string;
}
export const TicketsModal = ({ eventId, eventName }: IProps) => {
  const { t } = useTranslation();
  const { data } = useMyOrdersTicketId(eventId);
  const { onSubmit } = useMyTicketsDownload();
  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{eventName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody maxH="700px" overflow="auto">
          <VStack spacing={5} align="center">
            {data?.body?.map((ticket, index) => (
              <Box
                key={ticket.id}
                w="100%"
                p={5}
                mb={4}
                border="1px dashed #e2e2e2"
                borderRadius="10px"
                bg="gray.50"
                textAlign="center"
              >
                <Heading size="sm" mb={4}>
                  {t("ticket")} #{index + 1}
                </Heading>
                <Image
                  src={`data:;base64,${ticket.qrCode}`}
                  alt="QR Code"
                  boxSize="150px"
                  margin="auto"
                  mb={5}
                />
                <Box textAlign={"left"}>
                  <Text>
                    <span style={{ fontWeight: "bold" }}>
                      {t("name")}:&nbsp;
                    </span>
                    {`${ticket.name} ${ticket.surname}`}
                  </Text>
                  <Text>
                    <span style={{ fontWeight: "bold" }}>
                      {t("ticket-type")}:&nbsp;
                    </span>
                    {ticket.ticketName}
                  </Text>
                  <Text>
                    <span style={{ fontWeight: "bold" }}>
                      {t("description")}:&nbsp;
                    </span>
                    {ticket.description}
                  </Text>
                  <Text>
                    <span style={{ fontWeight: "bold" }}>
                      {t("date")}:&nbsp;
                    </span>
                    {ticket.startDate.split("-")[2] +
                      " " +
                      EMonthsTicket[ticket.startDate.split("-")[1]]}
                    , {ticket.startTime.slice(0, 5)}
                  </Text>
                  <Text as="span" fontWeight="bold">
                    {t("venue")}:&nbsp;
                  </Text>
                  <Link
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      ticket.address
                    )}`}
                    target="_blank"
                    color="blue"
                  >
                    {ticket.address}
                  </Link>

                  <Text mt="20px">
                    <span style={{ fontWeight: "bold" }}>
                      {t("order-id")}:&nbsp;
                    </span>
                    {ticket.id}
                  </Text>
                  <Text>
                    <span style={{ fontWeight: "bold" }}>
                      {t("cost")}:&nbsp;
                    </span>
                    {!!ticket.price ? `${ticket.price} ₼` : "FREE"}
                  </Text>
                </Box>
                <Button
                  leftIcon={<DownloadIcon />}
                  mt={4}
                  onClick={() => onSubmit(ticket.id)}
                >
                  {t("download-ticket")}
                </Button>
              </Box>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </>
  );
};
